import type { ZodIssueMetadata } from '@safc/configuration';
import { AssuranceLevel } from '@safc/configuration';

import {
  getIssueModalSettings,
  type IssueModalMode,
} from './issueModalMode.js';

export const getInitialIssueData = ({
  initialIssueMetadata,
  accountId,
  mode,
}: {
  initialIssueMetadata: Partial<ZodIssueMetadata>;
  accountId?: string;
  mode: IssueModalMode;
}): Partial<ZodIssueMetadata> => {
  if (!getIssueModalSettings(mode).applyIssuanceDefaults) {
    return initialIssueMetadata;
  }

  return {
    ...(initialIssueMetadata ?? {}),
    // on first issuance: set anything (but not REV), because it is required by the schema, gonna be validated/changed by RA anyway
    assuranceLevel: AssuranceLevel.VAL,
    accountId,
  };
};
